import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark py-12 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-81">
      <div className="max-w-2xl mx-auto text-center" data-id="element-82">
        <div className="mb-6" data-id="element-83">
          <span className="text-brand-lilac font-bold text-xl flex items-center justify-center gap-2" data-id="element-84">
            <span data-id="element-85">Ψ</span> PsiRecursos Pro™
          </span>
        </div>

        <p className="text-gray-400 text-sm mb-8 max-w-md mx-auto" data-id="element-86">
          El sistema N°1 de recursos para estudiantes de Psicología en
          Argentina. Organizate, entendé más y avanzá con confianza.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-gray-300 mb-8" data-id="element-87">
          <a href="mailto:psirecursospro@gmail.com" className="hover:text-white transition-colors" data-id="element-88">
            📧 psirecursospro@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-89">·</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-90">
            📱 @psirecursospro
          </span>
          <span className="hidden sm:inline" data-id="element-91">·</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-92">
            🌐 psirecursospro.com
          </span>
        </div>

        <div className="text-xs text-gray-500 space-y-2" data-id="element-93">
          <p data-id="element-94">© PsiRecursos Pro™ 2026 — Todos los derechos reservados.</p>
          <p className="italic" data-id="element-95">Ψ "Tu esfuerzo hoy. Tu impacto mañana."</p>
        </div>
      </div>
    </footer>;
}